import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";

import { createAutocomplete } from '@algolia/autocomplete-core';
import { Input } from "antd";
import { SearchNormal1 } from 'iconsax-react';

import pagesJson from './search-data/algolia-pages.json';
import { getGeneralSearch } from '../../../redux/dashboard/dashboardActions';

export default function HeaderSearch(props) {
  const [autocompleteState, setAutocompleteState] = useState({});

  const { generalSearchList } = useSelector((state) => state.dashboard);

  useEffect(async () => {
    await getGeneralSearch({ cardCode: localStorage.getItem('cardCode') });
  }, []);

  const autocomplete = useMemo(
    () =>
      createAutocomplete({
        onStateChange({ state }) {
          setAutocompleteState(state);
        },
        getSources() {
          return [
            {
              sourceId: 'combined-source',
              getItemInputValue({ item }) {
                return item.query || item.se1;
              },
              getItems({ query }) {
                if (!query) return [...pagesJson, ...generalSearchList];

                const filteredPages = pagesJson.filter((item) =>
                  item.title.toLowerCase().includes(query.toLowerCase())
                );

                const filteredGeneralData = generalSearchList.filter((item) => {
                  return (
                    item.se1.toLowerCase().includes(query.toLowerCase()) ||
                    item.se2.toLowerCase().includes(query.toLowerCase()) ||
                    item.se3.toLowerCase().includes(query.toLowerCase()) ||
                    item.type.toLowerCase().includes(query.toLowerCase())
                  );
                });

                return [...filteredPages, ...filteredGeneralData];
              },
              getItemUrl({ item }) {
                const pageItem = pagesJson.find((page) => page.type === item.type);
                return item.url || pageItem?.url || '#';
              },
              templates: {
                item({ item }) {
                  let displayText = '';

                  if (item.se1) displayText += item.se1;

                  if (item.se2) displayText += item.se2 ? ` / ${item.se2}` : ''; // Only add if se2 is not empty

                  if (item.se3) displayText += item.se3 ? ` / ${item.se3}` : ''; // Only add if se3 is not empty

                  if (item.type) {
                    const matchingPage = pagesJson.find((page) => page.type === item.type);
                    if (matchingPage) {
                      displayText += ` - ${matchingPage.title}`;
                    } else {
                      displayText += ` - <strong>${item.type}</strong>`; // Bold item type
                    }
                  }

                  return <span dangerouslySetInnerHTML={{ __html: displayText }} />;
                },
              }
            },
          ];
        },
      }),
    [generalSearchList]
  );

  function linkHandleClick() {
    autocompleteState.query = "";
    props.setSearchHeader(false);
  }

  return (
    <div {...autocomplete.getRootProps({})}>
      <Input
        {...props.inputFocusProp}
        {...autocomplete.getInputProps({})}
        placeholder="Search..."
        prefix={<SearchNormal1 size="16" className="hp-text-color-black-0 hp-text-color-dark-0" />}
      />

      <div className="hp-header-search-result" {...autocomplete.getPanelProps({})}>
        {autocompleteState.isOpen &&
          autocompleteState.collections.map((collection, index) => {
            const { source, items } = collection;

            return (
              items.length > 0 && (
                <ul key={index} {...autocomplete.getListProps()}>
                  {items.map((item, index) => (
                    index < 4 && (
                      <li
                        key={index}
                        {...autocomplete.getItemProps({ item, source })}
                        className="hp-font-weight-500"
                      >
                        <Link
                          to={item.url || (pagesJson.find((page) => page.type === item.type)?.url || "#")}
                          onClick={linkHandleClick}
                        >
                          {item.title || (
                            <span dangerouslySetInnerHTML={{ __html: `<strong>${item.type}</strong> - ${item.se1}${item.se2 ? ` / ${item.se2}` : ''}${item.se3 ? ` / ${item.se3}` : ''}` }} />
                          )}
                        </Link>
                      </li>
                    )
                  ))}
                </ul>
              )
            );
          })}
      </div>
    </div>
  );
}
